import { Helmet } from "react-helmet-async";
// @mui
import { Container } from "@mui/material";
import Document from "src/components/Document/Document";
// ----------------------------------------------------------------------

export default function AccountDocument() {
  return (
    <>
      <Helmet>
        <title> AccountDocument </title>
      </Helmet>

      <Container maxWidth="xl">
        <Document Role="Account" />
      </Container>
    </>
  );
}
